import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import ErrorBoundary from './components/ErrorBoundary';
import TrackingPageAppWithUrl from './containers/TrackingPageAppWithUrl';
import TrackingPageApp from './containers/TrackingPageApp';

function renderOrangeTrackingPage(elementId, store) {
  render(
    <ErrorBoundary>
      <Provider store={store}>
        <TrackingPageAppWithUrl pathname={window.location.pathname}>
          {({ trackingPageId, orderId, zipCode }) => (
            <TrackingPageApp trackingPageId={trackingPageId} orderId={orderId} zipCode={zipCode} />
          )}
        </TrackingPageAppWithUrl>
      </Provider>
    </ErrorBoundary>,
    document.getElementById(elementId)
  );
}

export default renderOrangeTrackingPage;



// WEBPACK FOOTER //
// ./src/js/renderOrangeTrackingPage.js